import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiMoreHorizontal, FiLock } from "react-icons/fi";
import { Dropdown } from 'react-bootstrap';
import TimeTypeEditModal from 'components/TimeTypes/TimeTypeEditModal';
import { showModal, hideModal } from "actions/modalActions";
import * as timesActions from 'actions/timesActions';
import { toastr } from 'react-redux-toastr';
import { timeTypesService } from "services";
import { errorFormating } from "utils/utils";
import DataTable from "components/DataTable";
import { withTranslation } from 'react-i18next';

class TimeTypesList extends Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openEditTimeTypeModal = this.openEditTimeTypeModal.bind(this);
		this.openDeleteTimeTypeModal = this.openDeleteTimeTypeModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	componentDidMount() {

	}

	closeModal() {
		this.props.hideModal()
	}

	openEditTimeTypeModal(time_type) {
		this.props.showModal({
			open: true,
			title: this.props.t('timeTypes.editTimeType'),
			style: { width: '400px' },
			content: <TimeTypeEditModal time_type={time_type} handleClose={this.closeModal} />,
			closeModal: this.closeModal
		}, 'edit')
	}

	openDeleteTimeTypeModal(idTimeType) {
		this.props.showModal({
			open: true,
			title: this.props.t('timeTypes.deleteTimeType'),
			style: { width: '400px' },
			message: this.props.t('timeTypes.deleteConfirmation'),
			deleteAction: () => this.confirmDelete(idTimeType),
			closeModal: this.closeModal
		}, 'delete')
	}

	openAlertModal(message, title) {
		this.props.showModal({
			open: true,
			title: title || this.props.t('timeTypes.deleteError'),
			style: { width: '400px' },
			message: message,
			closeModal: this.closeModal
		}, 'alert')
	}

	confirmDelete = async (idTimeType) => {
		const response = await timeTypesService.remove(idTimeType);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		}
		else {
			this.props.getTimeTypes();
			this.closeModal();
		}
	}

	setTimeTypeEnabled = async (time_type, enabled) => {
		if (this.updatingTimeTypeId === time_type.id) {
			return;
		}

		this.updatingTimeTypeId = time_type.id;
		const response = await timeTypesService.update({
			...time_type,
			enabled,
		});
		this.updatingTimeTypeId = null;

		if (!response.ok) {
			const textError = errorFormating(response);
			this.openAlertModal(textError.general || this.props.t('common.errorGeneric'), this.props.t('common.error'));
			return;
		}

		toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
		this.props.getTimeTypes();
	}

	getTimeTypeMenu = (time_type) => (
		<Dropdown align={time_type.system ? "end" : undefined}>
			<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
			<Dropdown.Menu>
				{time_type.system ? (
					<Dropdown.Item
						as="button"
						onClick={() => this.setTimeTypeEnabled(time_type, !time_type.enabled)}
					>
						{time_type.enabled
							? this.props.t('timeTypes.deactivate')
							: this.props.t('timeTypes.activate')}
					</Dropdown.Item>
				) : (
					<Dropdown.Item as="button" onClick={() => this.openEditTimeTypeModal(time_type)}>{this.props.t('common.edit')}</Dropdown.Item>
				)}
				<Dropdown.Item as="button" onClick={() => this.openDeleteTimeTypeModal(time_type.id)}>{this.props.t('common.delete')}</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	getTimeTypeActions = (time_type) =>
		time_type.system ? (
			<div className="time-type-system-actions">
				<FiLock className="icon-locked" title={this.props.t('timeTypes.systemType')} />
				{this.getTimeTypeMenu(time_type)}
			</div>
		) : (
			this.getTimeTypeMenu(time_type)
		);

	getTimeTypeColumns = () => [
		{
			key: "name",
			header: this.props.t('common.name'),
			render: (time_type) =>
				time_type.system ? (
					time_type.name
				) : (
					<button
						type="button"
						className="btn-transparent btn-editable"
						onClick={() => this.openEditTimeTypeModal(time_type)}
					>
						{time_type.name}
					</button>
				),
		},
		{
			key: "status",
			header: this.props.t('common.status'),
			align: "center",
			render: (time_type) =>
				time_type.enabled ? (
					<span title={this.props.t('common.active')} className="estado estado-si">{this.props.t('common.active')}</span>
				) : (
					<span title={this.props.t('common.inactive')} className="estado estado-no">{this.props.t('common.inactive')}</span>
				),
		},
		{
			key: "work_time",
			header: this.props.t('timeTypes.headerWorkTime'),
			headerClassName: "hidden-xs",
			className: "hidden-xs",
			render: (time_type) => (time_type.work_time ? this.props.t('common.yes') : this.props.t('common.no')),
		},
	];

	render() {
		const time_types = this.props.time_types || [];

		return (
			<DataTable
				tableClassName="table-timeTypes table-hover"
				tableStyle={{ backgroundColor: "#ffffff" }}
				columns={this.getTimeTypeColumns()}
				rows={time_types}
				rowKey={(row) => row.id}
				emptyMessage={this.props.t('common.noResults')}
				actionsColumn={{
					render: (time_type) => this.getTimeTypeActions(time_type),
					className: "td-actions",
				}}
			/>
		);
	}
}


const mapStateToProps = (reducers) => {
	return reducers.calendarsReducer;
};

const mapDispatchToProps = dispatch => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }))
	},
	getTimeTypes: (q) => dispatch(timesActions.getTimeTypes(q)),
})


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TimeTypesList))